import React from "react";
import {
  Container,
  SubTitle,
  Title,
  BackgroundImage,
} from "./styled.components";

const Hero = (props) => {
  return (
    <Container>
      {props.BackgroundImage && (
        <BackgroundImage>{props.backgroundImage}</BackgroundImage>
      )}
      <Title>{props.title}</Title>
      <SubTitle>{props.SubTitle}</SubTitle>
    </Container>
  );
};

export default Hero;
